module.exports = __webpack_public_path__ + "img/bg_classify5.786c2fd2.png";